import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Checkbox } from "@/components/ui/checkbox";
import { Control } from "react-hook-form";
import { getShirtSizeDisplay, getAllShirtSizes } from "@/types/shirtSizes";
import { EmployeeFormValues } from "../schemas/employeeFormSchema";

interface UniformBadgeInfoFormProps {
  control: Control<EmployeeFormValues>;
}

export const UniformBadgeInfoForm = ({
  control,
}: UniformBadgeInfoFormProps) => {
  return (
    <div className="p-6 border-b">
      <h3 className="text-lg font-semibold mb-4">Onboarding Details</h3>
      <div className="space-y-4">
        <FormField
          control={control}
          name="howDidYouHearAboutUs"
          render={({ field }) => (
            <FormItem>
              <FormLabel>How did you hear about us?</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder="e.g. Friend, Social Media, etc."
                />
              </FormControl>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="shirtSize"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Shirt Size (For Company Uniform)</FormLabel>
              <Select onValueChange={field.onChange} value={field.value || ""}>
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder="Select a size" />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {getAllShirtSizes().map((size) => (
                    <SelectItem key={size} value={size}>
                      {getShirtSizeDisplay(size)}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="receivedShirt"
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0 py-2">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <FormLabel className="font-normal">Shirt Received</FormLabel>
            </FormItem>
          )}
        />
        <FormField
          control={control}
          name="badgeReceived"
          render={({ field }) => (
            <FormItem className="flex flex-row items-start space-x-3 space-y-0 py-2">
              <FormControl>
                <Checkbox
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
              <FormLabel className="font-normal">Badge Received</FormLabel>
            </FormItem>
          )}
        />
      </div>
    </div>
  );
};
